export const apiUrl=process.env.REACT_APP_API_URL
export const camelize: any = (str: any) => {
    return str.replace(/\W+(.)/g, function (match: any, chr: any) {
        return chr.toUpperCase();
    });
}
export const sas= process.env.REACT_APP_SAS
export const yeldamwebimagessas = "sp=r&st=2023-12-14T05:59:48Z&se=2028-12-14T13:59:48Z&sv=2022-11-02&sr=c&sig=Jy10HzdxEVlYTgi9Dne%2BMn0T2%2FiQ0nP5u5moMhC87cw%3D"